import lazyWithRetry from 'tools/lazyWithRetry';

const component = lazyWithRetry(() => import(
	/* webpackChunkName: "AllocationRequestDashboardPage" */
	'pages/supplier/AllocationRequest/AllocationRequestDashboardPage'));

export default [{ component, exact: true, path: '/allocation_requests/:allocationRequestId' }];